<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.DeclarationHistory')"
    width="690px"
    :close-on-click-modal="false"
    class="app-main-inner edi-declarate-record-dialog"
  >
    <div class="app-main-inner-row row-grid-dialog" style="padding-top: 0;">
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="searchConditions.total>0"
        :total="searchConditions.total"
        :page.sync="searchConditions.pageNum"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchHistory"
      />
    </div>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import * as ediApi from '@/api/seaExport/edi'

export default {
  name: 'DeclarateRecordDialog',
  props: {
    visible: { type: Boolean, required: true },
    params: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      searchConditions: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      rowData: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_OperateTime'),
          field: 'dateCreated',
          width: 140
        }, {
          headerName: this.$t('FileHistory.operation'),
          field: 'operate',
          width: 110
        }, {
          headerName: this.$t('SeaExport.Content'),
          field: 'requestMsg',
          width: 150,
          tooltip: (params) => {
            return params.data.requestMsg
          }
        }, {
          headerName: this.$t('SeaExport.CredentialNumber'),
          field: 'crn',
          width: 90
        }, {
          headerName: this.$t('Payment.status'),
          field: 'state',
          width: 80
        }, {
          headerName: this.$t('SeaExport.ResponseCode'),
          field: 'code',
          width: 80
        }
      ]
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.fetchHistory()
      }
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  mounted() {
  },
  methods: {
    fetchHistory() {
      // 根据params获取历史记录
      const self = this
      const pageNum = self.searchConditions.pageNum
      const pageSize = self.searchConditions.pageSize
      const params = { pageNum, pageSize }
      // 执行查询
      ediApi.queryScfiHistoryPageable(params).then(resp => {
        // 赋值结果
        self.searchConditions.total = resp.data.total ? Number(resp.data.total) : 0
        const rowData = resp.data.list
        // 移除requestMsg中的header，如果有的话
        for (const row of rowData) {
          if (row.requestMsg && row.requestMsg.trim() !== '') {
            const requestMsg = JSON.parse(row.requestMsg)
            if (requestMsg.hasOwnProperty('header')) {
              requestMsg.header = undefined
              row.requestMsg = JSON.stringify(requestMsg)
            }
          }
        }
        this.rowData = rowData
      }).catch(error => {
        this.$message.error(error)
      })
    }
  }
}
</script>

<style lang="scss">
.edi-declarate-record-dialog {
  .el-dialog__body {
    padding: 0 !important;
  }
}
</style>
